module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAVhJREFUKFNtkrtKA1EQhr9ZFjGNCha+hI1NmkXQwsY6L5FYKCKiXVQUL6BJkeQhYq0giEpQQbHzIWKh2AhGs/nl7LqbIzjNuc7831wMz84OFcXGCmLWYBJ4RXQCo7a4brfZV3Obq6rCjwJ1M8oSllwCySoIDGlAa7TH8nzV+sn9+YEaEpX8o+fgBzBoLmzakl0cKpLoMEgDZ46Fcfh8H57doxlK0C/21TZRchiZQxDC3BrcHIHiFNFTPLXLPXWBqZw/hHAEohW4O4H4C9T/o/hi17v6BkIXbXQCipUEIzcJnhrQG6L2rbOrrsSU/eI5NKdUXIWHYxj0UiUP78Vud9QGSn9KHEJxAx73f9G8nAJxavfbiszooDRYpuhQHVJ2zqoXWNJ4eKiqgVHJquSllDh5aM2ZLVvKJ2IM6gblXNHrmbnuGK038yYiK9XztqI4/mf2oDa9M5y9H3iPiZx21H0nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/add.png
// module id = It4q
// module chunks = 1